<template>
  <div>
    <h1 class="show-in-mobile">Generadores</h1>
    <div class="filter-container" style="margin-bottom:10px; text-align:left">
      <span style="margin-right: 10px">Filtrar</span>
      <el-input
        v-model="search"
        size="mini"
        placeholder="Nombre o Razón Social"
        style="width: 150px; margin-right:5px"
      />
      <el-button
        v-if="hasPermission('edit')"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        size="mini"
        @click="handleDownload"
        :loading="loadingExportButton"
      >
        <span v-if="!is_mobile">Exportar</span>
      </el-button>
      <el-button
        v-if="hasPermission('edit')"
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="handleCreate"
      >
        <span v-if="!is_mobile">Nuevo generador</span>
      </el-button>
    </div>

    <el-table
      v-loading="loading"
      element-loading-text="Cargando..."
      :data="userList.filter(data => !search || data.full_name.toLowerCase().includes(searchInLowerCase) || data.business.toLowerCase().includes(searchInLowerCase))"
      ref="userListFiltered"
      :default-sort="{prop: 'full_name', order: 'ascending'}"
      style="width: 100%"
      @row-dblclick="handleView"
    >
      <el-table-column
        prop="status"
        label="Estado"
        width="85"
        :filters="[{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }]"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_active ? 'success' : 'danger'"
            @click="handleStatus(scope.$index, scope.row)"
            style="cursor:pointer;"
            disable-transitions
          >{{scope.row.is_active ? 'Activo' : 'Inactivo'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Apellido y Nombre" prop="full_name" sortable min-width="180"></el-table-column>
      <el-table-column label="Razón Social" prop="business" min-width="200">
        <template slot-scope="scope">
          {{scope.row.business}}<br>
          {{scope.row.activity_t}}
        </template>
      </el-table-column>
      <el-table-column label="Teléfono" prop="phone" min-width="140"></el-table-column>
      <el-table-column label="Email" prop="email" min-width="200"></el-table-column>
      <el-table-column
        label="Zona"
        min-width="230"
        :filters="zones"
        :filter-method="filterZone"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            v-for="zone in scope.row.zones"
            :key="zone"
            disable-transitions
            style="margin-right:5px"
          >{{zone}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="right" min-width="120">
        <template slot-scope="scope">
          <el-button v-if="hasPermission('edit')" size="mini" @click="handleEdit(scope.row)" icon="el-icon-edit" />
          <el-button
            v-if="hasPermission('all')"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>

    <!-- Modal Form -->
    <el-dialog
      :title="modal.name"
      :visible.sync="dialogFormVisible"
      width="60%"
      @close="handleDialogClose"
    >
      <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
        <el-row>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Nombre" prop="first_name">
              <el-input v-model="form.first_name" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Apellido" prop="last_name">
              <el-input v-model="form.last_name" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" autocomplete="off" type="email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Teléfono" prop="phone">
              <el-input v-model="form.phone" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Actividad" prop="activity">
              <el-select
                v-model="form.activity"
                placeholder="Seleccione"
                filterable
                :disabled="modal.readOnly"
              >
                <el-option
                  v-for="activity in activities"
                  :key="activity.value"
                  :label="activity.text"
                  :value="activity.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Razón Social">
              <el-input v-model="form.business" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="CUIT">
              <el-input v-model="form.cuit" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Domicilio Fiscal">
              <el-input
                v-model="form.business_address"
                autocomplete="off"
                :readonly="modal.readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Ciudad">
              <el-input v-model="form.business_city" autocomplete="off" :readonly="modal.readOnly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Provincia">
              <el-select
                v-model="form.business_province"
                placeholder="Seleccione"
                filterable
                :disabled="modal.readOnly"
              >
                <el-option
                  v-for="province in provinces"
                  :key="province"
                  :label="province"
                  :value="province"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Residuos" prop="trash_type">
              <el-select
                v-model="form.trash_type"
                multiple
                placeholder="Seleccione"
                filterable
                allow-create
                @change="handleChangeTrashType"
                :disabled="modal.readOnly"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Notas">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                v-model="form.notes"
                :readonly="modal.readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Activo" style="text-align:left">
              <el-switch v-model="form.is_active" :disabled="modal.readOnly"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="Habilitado OPDS" style="text-align:left">
              <el-switch v-model="form.is_legal" :disabled="modal.readOnly"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <div class="locations">
              <h3>Ubicaciones</h3>
              <p v-if="locationError.show" style="font-size: 12px; margin-top: -15px; color: #F56C6C;">
                Debe ingresar al menos una ubicación
              </p>
              <el-form
                :model="location"
                ref="formLocation"
                :rules="rulesLocation"
                v-if="!modal.readOnly"
              >
                <el-row v-if="dialogFormLocationVisible">
                  <el-col :xs="24" :md="12">
                    <el-form-item label="Nombre" prop="name" :label-width="formLabelWidthLocation">
                      <el-input v-model="location.name" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item label="Zona" prop="zone" :label-width="formLabelWidthLocation">
                      <el-select
                        v-model="location.zone"
                        filterable
                        placeholder="Seleccione"
                        size="small"
                        @change="handleUpdateZoneId"
                      >
                        <el-option
                          v-for="zone in zones"
                          :key="zone.value"
                          :label="zone.label"
                          :value="zone.value"
                          :disabled="zone.disabled"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item
                      label="Dirección Operativa"
                      prop="address"
                      :label-width="formLabelWidthLocation"
                    >
                      <el-input v-model="location.address" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item label="Ciudad" prop="city" :label-width="formLabelWidthLocation">
                      <el-input v-model="location.city" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item
                      label="Provincia"
                      prop="province"
                      :label-width="formLabelWidthLocation"
                    >
                      <el-select
                        v-model="location.province"
                        placeholder="Seleccione"
                        filterable
                        size="small"
                      >
                        <el-option
                          v-for="province in provinces"
                          :key="province"
                          :label="province"
                          :value="province"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item label="Días de atención" :label-width="formLabelWidthLocation">
                      <el-input v-model="location.attention_days" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item
                      label="Horarios de atención"
                      :label-width="formLabelWidthLocation"
                    >
                      <el-input v-model="location.attention_hours" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item
                      label="Encargado"
                      prop="responsable"
                      :label-width="formLabelWidthLocation"
                    >
                      <el-input v-model="location.responsable" autocomplete="off" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12">
                    <el-form-item
                      label="Teléfono"
                      prop="responsable_phone"
                      :label-width="formLabelWidthLocation"
                    >
                      <el-input
                        v-model="location.responsable_phone"
                        autocomplete="off"
                        size="small"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" style="text-align:right">
                    <el-button @click="handleResetLocation()" size="small">Vaciar</el-button>
                    <el-button @click="handleCancelLocation()" size="small">Cancelar</el-button>
                    <el-button
                      type="primary"
                      @click="handleSaveLocationButton('formLocation')"
                      size="small"
                    >Guardar</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-table :data="form.locations" style="width: 100%" :style="locationError.style">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <p>
                    <strong>Dirección Operativa:</strong>
                    {{ props.row.address }}, {{ props.row.city }} ({{ props.row.province }})
                  </p>
                  <p>
                    <strong>Días y horario de atención:</strong>
                    {{ props.row.attention_days }} - {{ props.row.attention_hours }}
                  </p>
                  <p>
                    <strong>Encargado:</strong>
                    {{ props.row.responsable }} - {{ props.row.responsable_phone }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="Nombre" prop="name"></el-table-column>
              <el-table-column label="Zona" prop="zone"></el-table-column>
              <el-table-column align="right" v-if="!modal.readOnly">
                <template slot="header">
                  <el-button size="mini" type="primary" @click="handlCreateLocation()">Nueva</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEditLocation(scope.$index, scope.row)"
                    icon="el-icon-edit"
                  />
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDeleteLocation(scope.$index)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :xs="24">
            <h3 style="margin-top:40px">Frecuencia de recolección</h3>
            <el-row>
              <el-col :xs="24" :md="8" v-for="item in activityStates" :key="item.value">
                 {{ item.label }} 
                <el-input v-model="form.frecuency[item.value]" :readonly="modal.readOnly" autocomplete="off" style="width:60px; margin: 10px"></el-input> Días
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!modal.readOnly">
        <el-button @click="dialogFormVisible = false" size="medium">Cancelar</el-button>
        <el-button
          :loading="loadingSaveButton"
          type="primary"
          @click="handleSaveButton('form')"
          size="medium"
        >Guardar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { db } from "@/main";
import cleanObject from '@/vendor/CleanObject'

export default {
  data() {
    return {
      loading: false,
      loadingSaveButton: false,
      loadingExportButton: false,
      search: "",
      dialogFormVisible: false,
      dialogFormLocationVisible: false,

      form: {
        first_name: "",
        last_name: "",
        email:'',
        phone: "",
        business_address: "",
        business: "",
        business_city: "Bahía Blanca",
        business_province: "Buenos Aires",
        cuit: "",
        activity: "",
        trash_type: [],
        notes: "",
        is_active: true,
        is_legal: false,
        locations: [],
        frecuency: {}
      },
      rules: {
        first_name: [
          {
            required: true,
            message: "Debe ingresar un nombre",
            trigger: "blur"
          }
        ],
        last_name: [
          {
            required: true,
            message: "Debe ingresar un apellido",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: 'Debe ingresar un email', trigger: 'blur' }
        ],
        phone: [
          {
            required: true,
            message: "Debe ingresar un teléfono",
            trigger: "blur"
          }
        ],
        activity: [
          {
            required: true,
            message: "Debe ingresar una actividad",
            trigger: "change"
          }
        ],
        trash_type: [
          {
            type: "array",
            required: true,
            message: "Debe ingresar al menos un tipo de residuo",
            trigger: "change"
          }
        ]
      },
      rulesLocation: {
        name: [
          {
            required: true,
            message: "Debe ingresar un nombre",
            trigger: "blur"
          }
        ],
        zone: [
          { required: true, message: "Debe ingresar una zona", trigger: "blur" }
        ],
        address: [
          {
            required: true,
            message: "Debe ingresar una dirección",
            trigger: "blur"
          }
        ],
        city: [
          {
            required: true,
            message: "Debe ingresar una ciudad",
            trigger: "blur"
          }
        ],
        province: [
          {
            required: true,
            message: "Debe seleccionar una provincia",
            trigger: "change"
          }
        ],
        responsable: [
          {
            required: true,
            message: "Debe ingresar un responsable",
            trigger: "blur"
          }
        ],
        responsable_phone: [
          {
            required: true,
            message: "Debe ingresar un teléfono de contacto",
            trigger: "blur"
          }
        ]
      },
      location: {
        name: "",
        zone: "",
        zone_id: '',
        address: "",
        city: "",
        province: "",
        attention_days: "",
        attention_hours: "",
        responsable: "",
        responsable_phone: "",
        index: -1
      },
      formLabelWidth: "120px",
      formLabelWidthLocation: "150px",
      modal: {
        name: "",
        status: "",
        readOnly: false
      },
      oldLocations: []
    };
  },
  async created() {
    this.$store.commit("CHANGE_SECTION", { name: "Generadores", index: "2" });

    this.loading = true;
    await this.$store.dispatch("getUsers");
    await this.$store.dispatch("getZones");
    this.loading = false;
  },
  methods: {
    hasPermission( permissionReq ) {
      return this.$store.getters.hasPermission('Users', permissionReq)
    },
    msgSuccess(text) {
      this.$message({
        type: "success",
        message: text
      });
    },
    msgError(text) {
      this.$message({
        type: "error",
        showClose: true,
        duration: 0,
        message: text
      });
    },
    // *******************
    // USER LIST
    // *******************
    filterStatus(value, row) {
      return row.is_active === value;
    },
    filterZone(value, row) {
      return row.zones.includes(value);
    },
    handleDialogClose() {
      if (this.modal.status !== "view") {
        // Reset form validations
        this.$refs["form"].resetFields();
        this.$refs["formLocation"].resetFields();
        
        // Clear location form on accidental close dialog
        cleanObject(this.location)
        this.location.index = -1
        this.dialogFormLocationVisible = false

        // Revert changes in locations
        for (let i = 0; i < this.oldLocations.length; i++) {
          this.form.locations[i] = this.oldLocations[i];
        }
      }

      cleanObject(this.form)
      this.is_active = true
      this.form.business_city = "Bahía Blanca"
      this.form.business_province = "Buenos Aires"
    },
    handleView(row, column, event) {
      this.modal = { name: "Ver Generador", status: "view", readOnly: true };
      this.form = { ...row };
      this.dialogFormVisible = true;
    },
    handleCreate(index, row) {
      if( this.hasPermission('edit') ) {
        this.modal = { name: "Nuevo Generador", status: "add", readOnly: false };
        this.dialogFormVisible = true;
      }
    },
    handleEdit(row) {
      if( this.hasPermission('edit') ) {
        this.modal = { name: "Editar Generador", status: "edit", readOnly: false };
        this.form = { ...row };
        delete this.form.zones
        this.dialogFormVisible = true;

        // Make a copy of form.locations
        this.oldLocations = [];
        for (let i = 0; i < this.form.locations.length; i++) {
          this.oldLocations[i] = this.form.locations[i];
        }
      }
    },
    handleChangeTrashType(trashType) {
      // If remove trash_type, remove the reference in the object form.frecuency, to remove in the DB when is updated
      if( this.form.frecuency ) {
        const objFrecuency = Object.keys(this.form.frecuency)
        objFrecuency.forEach( e => {
          if( !trashType.includes(e) )
            delete this.form.frecuency[e]
        })
      }
    },
    handleSaveButton(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid && this.form.locations.length > 0) {
          // Valid form
          this.loadingSaveButton = true;
          if (this.modal.status === "add" ) {
            await this.$store
              .dispatch("addUser", this.form)
              .then(() => {
                this.msgSuccess("El generador fue agregado");
              })
              .catch(() => {
                this.msgError("Hubo un error agregando el generador");
              });
          } else {
            await this.$store
              .dispatch("updateUser", this.form)
              .then(() => {
                this.msgSuccess("El generador fue actualizado");
              })
              .catch(() => {
                this.msgError(
                  "Error actualizando el generador, probablemente ya no exista en la base de datos. Recargue la página"
                );
              });
          }
          this.loadingSaveButton = false;
          this.dialogFormVisible = false;
        }
      });
    },
    handleStatus(index, row) {
      if( this.hasPermission('edit') ) {
        let statusText = row.is_active ? "Desactivar" : "Activar";
        this.$confirm(
          "Desea " + statusText.toLowerCase() + " al generador " + row.full_name,
          statusText,
          {
            confirmButtonText: statusText,
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        ).then(() => {
          this.$store
            .dispatch("toggleStatusUser", row)
            .then(() => {
              this.msgSuccess("El generador fue actualizado");
            })
            .catch(() => {
              this.msgError(
                "Error actualizando el generador, probablemente ya no exista en la base de datos. Recargue la página"
              );
            });
        }).catch(() => {})
      }
    },
    handleDelete(row) {
      this.$confirm(
        "Estás por borrar completamente el generador " + row.full_name,
        "Borrar",
        {
          confirmButtonText: "Borrar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        this.$store
          .dispatch("deleteUser", row)
          .then(() => {
            this.msgSuccess("El generador fue eliminado");
          })
          .catch(() => {
            this.msgError("Error eliminando el generador");
          })
      }).catch(() => {})
    },
    handleDownload() {
      this.loadingExportButton = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          'Estado', 'Apellido y Nombre', 'Apellido', 'Nombre',
          'Email', 'Teléfono', 'Actividad', 'Razón Social', 'CUIT',
          'Dirección Fiscal', 'Ciudad', 'Provincia', 
          'Residuos', 'Notas', 'Habilitado OPDS', 'Zonas', 'Ubicaciones'
          ];
        const filterVal = [
          'is_active', 'full_name', 'last_name', 'first_name', 
          'email', 'phone', 'activity_t', 'business', 'cuit',
          'business_address', 'business_city', 'business_province',
          'trash_type', 'notes', 'is_legal', 'zones', 'locations'
          ]; 
        const data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "generadores"
        });
        this.loadingExportButton = false;
      });
    },
    formatJson(filterVal) {
      // Export only visible elements, if use filter, only export filtered elements
      return this.$refs.userListFiltered.tableData.map(v =>
        filterVal.map(j => {
          if (j === "is_active") {
            return v.is_active ? "Activo" : "Inactivo";
          } else if (j === "is_legal") {
            return v.is_legal ? "SI" : "NO";
          } else if (j === "locations") {
            let locations = ""
            v.locations.forEach( loc => {
              locations += 'Nombre: ' + loc.name + ' (' + loc.zone + ')\n'
              locations += 'Dirección Operativa: ' + loc.address + ', ' + loc.city + ', ' + loc.province + '\n'
              if( loc.attention_days || loc.attention_hours ) {
                loc.attention_days = loc.attention_days ? loc.attention_days : ''
                loc.attention_hours = loc.attention_hours ? loc.attention_hours : ''
                locations += 'Días y horarios de atención: ' + loc.attention_days + ' ' + loc.attention_hours + '\n'
              }
              locations += 'Responsable: ' + loc.responsable + ' (' + loc.responsable_phone + ')\n'
              if( v.locations.length > 1 ) locations += '\n'
            })
            return locations
          } else if( j === 'trash_type') {
            let residuos = []
            v.trash_type.forEach( type => {
              const trash = this.options.find(e => e.value == type )
              if( trash )
                residuos.push(trash.label)
              else 
                residuos.push(type)
            })
            return residuos
          } else {
            return v[j];
          }
        })
      );
    },
    // *******************
    // LOCATIONS LIST
    // *******************
    handlCreateLocation() {
      // If dont have locations add the first with default data
      if ( Array.isArray(this.form.locations) && this.form.locations.length == 0 ) {
        this.location.address = this.form.business_address ? this.form.business_address : '';
        this.location.city = this.form.business_city ? this.form.business_city : 'Bahía Blanca';
        this.location.province = this.form.business_province ? this.form.business_province : '';
        this.location.attention_days = "Lunes a Sábados"
        this.location.responsable = this.form.last_name + ", " + this.form.first_name;
        this.location.responsable_phone = this.form.phone ? this.form.phone : '';
      }
      this.dialogFormLocationVisible = true;
    },
    handleEditLocation(index, row) {
      this.location = { ...row };
      this.location.index = index;
      this.dialogFormLocationVisible = true;
    },
    handleDeleteLocation(index) {
      this.$confirm("Desea eliminar esta ubicación", "Borrar Ubicación", {
        confirmButtonText: "Borrar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.form.locations.splice(index, 1);
      }).catch(() => {})
    },
    handleUpdateZoneId(zoneName) {
      const zone = this.zones.find(element => element.value === zoneName)
      this.location.zone_id = zone.id
    },
    handleSaveLocationButton(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // Remove index before save in DB
          const index = this.location.index
          delete this.location.index

          if (index >= 0) {
            // Edit location
            this.form.locations.splice(index, 1, this.location);
          } else {
            // Add new location
            this.form.locations.push(this.location);
          }

          this.dialogFormLocationVisible = false;
        }
      });
    },
    handleCancelLocation() {
      this.dialogFormLocationVisible = false;
      cleanObject(this.location)
      this.location.index = -1
    },
    handleResetLocation() {
      cleanObject(this.location)
      this.location.index = -1
    }
  },
  computed: {
    searchInLowerCase() {
      return this.search.toLowerCase().trim();
    },
    provinces() {
      return this.$store.state.provinces;
    },
    activities() {
      return this.$store.state.users.activities;
    },
    options() {
      return this.$store.state.orders.options;
    },
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    userList() {
      return this.$store.state.users.userList;
    },
    activityStates() {
      const ret = []
      let otherExist = false
      
      if( !this.form.trash_type )
        return ret

      if( this.form.trash_type.length > 0 && this.form.activity ) {
          this.form.trash_type.forEach( e => {

          const trash = this.options.find( option => option.value === e )
          if ( trash ) {
            ret.push(trash)
          } else if( !otherExist ) {
            otherExist = true
            ret.push({
              label: 'Otros',
              value: 'others'
            })
          }
        })
      }
      
      return ret
    },
    zones() {
      const zoneList = [];
      this.$store.state.zones.zoneList.forEach(zone => {
        if (!zoneList.includes(zone.name)) {
          // Add text and value for filter in table, and disable and label for select
          zoneList.push({
            text: zone.name,
            value: zone.name,
            disabled: !zone.is_active,
            label: zone.name,
            id: zone.id
          });
        }
      });

      // Order by name
      zoneList.sort(function(a, b) {
        var nameA = a.text.toUpperCase(); // ignore upper and lowercase
        var nameB = b.text.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      return zoneList;
    },
    current_user() {
      return this.$store.state.current_user
    },
    locationError() {
      const ret = {
        show: true,
        style: "border-color:#F56C6C !important"
      }
      return this.form.locations?.length > 0 ? {} : ret
    }
  }
};
</script>

<style>
@media screen and (max-width: 700px) {
  .el-dialog {
    width: 90% !important;
  }
}
.el-select {
  width: 100%;
}
.locations .el-form-item {
  margin-bottom: 25px;
}

.locations .el-row {
    border: 1px solid #c5c5c5;
    padding: 20px 15px 0px 15px;
    margin-bottom: 15px;
    background-color: #f7f7f7;
    border-radius: 4px;
}
</style>